import React from 'react'
import { useRouter } from 'next/router'
import { useGetProfile } from '@core/react-query/features/profile/hooks/useGetProfile'
import { useUnimpersonateUser } from '@core/react-query/features/support/hooks/useUnimpersonateUser'
import { useToast } from '@core/toast'
import { localizedStrings } from '@core/strings'
import { Button } from '@common/material'

export const SidebarUnimpersonateButton: React.FC = () => {
  const { data: profile } = useGetProfile()
  const unimpersonateMutation = useUnimpersonateUser()
  const router = useRouter()
  const toast = useToast()

  const handleUnimpersonateUser = () => {
    if (!profile?.id) return

    unimpersonateMutation.mutate(
      { unimpersonatedUserId: profile.id },
      {
        onSuccess: () => {
          toast.success(localizedStrings.unimpersonateUserSuccess)
          setTimeout(() => router.push('/'), 1000)
        },
        onError: () => {
          toast.error(localizedStrings.unimpersonateUserFailed)
        },
      },
    )
  }

  return (
    <Button
      variant='contained'
      color='error'
      size='small'
      fullWidth
      onClick={handleUnimpersonateUser}
      sx={{
        justifyContent: 'flex-start',
        textTransform: 'none',
        boxShadow: 'none',
        '&:hover': { boxShadow: 'none' },
      }}
      data-test='sidebar-unimpersonate-button'
    >
      {localizedStrings.unimpersonateUser}
    </Button>
  )
}
